import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IEditAuthorisedVisitorTemporaryWorkerRequestModel from "interfaces/Request/IEditAuthorisedVisitorTemporaryWorkerRequestModel";
import ISiteDiaryAuthorisedTemporaryWorkersViewModel from "interfaces/SiteDiary/AuthorisedTemporaryWorkers/ISiteDiaryAuthorisedTemporaryWorkersViewModel";
import { PencilSquare } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const EditTemplate = (props: ISiteDiaryAuthorisedTemporaryWorkersViewModel): any => {
  const {
    id, hwrcSiteId, diaryDate, name, organisation, inducted, timeIn, timeOut
  } = props;
  // eslint-disable-next-line max-len
  const editUrl = encodeURI(`${RoutePathsEnum.AuthorisedVisitorTemporaryWorkerEdit}/${hwrcSiteId}/${diaryDate}/${id}`);

  const editData : IEditAuthorisedVisitorTemporaryWorkerRequestModel = {
    name,
    organisation,
    inducted,
    timeIn: timeIn.toISOString(),
    timeOut: timeOut ? timeOut.toISOString() : undefined
  };

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };

  return (
    <>
      <Link data-testid="editAuthorisedVisitorButton" state={editData} to={editUrl} onContextMenu={handleContextMenu}>
        <PencilSquare color="#000" />
        <span className="visually-hidden">
          edit
          {name}
        </span>
      </Link>
    </>
  );
};
export default EditTemplate;
